import { makeAutoObservable, reaction } from 'mobx';
import { ringMaxStates, RINGS } from '../powerOfGodsCore/constants/matrixConstants';
import { isStage } from '../../../core/helpers/isMobile';
import { powerOfGodsStore } from './powerOfGodsStore';
import { symbolEnum } from '../powerOfGodsCore/constants/reelConstants';

export class MatrixStore {
  ringState = {
    big: 0,
    middle: 0,
    small: 0,
  };

  ringLoadingComplete = {
    big: true,
    middle: true,
    small: true,
  };

  ringActionTypes = {
    big: {
      reverse: false,
      bonusInit: false,
      cashOut: false,
    },
    middle: {
      reverse: false,
      lineCashOut: false,
      cashOut: false,
    },
    small: {
      reverse: false,
      lineCashOut: false,
      cashOut: false,
    },
  };

  isMedusaReversing = false;

  responseReady = false;

  isInBonusScene = false;

  responseData = null;

  winInfo = null;

  bonusInfo = null;

  isZeusDrop = null;

  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.responseData,
      (data) => {
        if (!data || typeof data !== 'object') return;

        const winOdd = this.winInfo?.odd;
        const autoCashOutRing = this.getAutoCashOutRing(winOdd);
        if (this.bonusInfo != null) {
          this.setRingState(RINGS[0], ringMaxStates[RINGS[0]]);
          return;
        }
        RINGS.forEach((name) => {
          if (autoCashOutRing === name) {
            this.setRingState(name, ringMaxStates[name]);
            return;
          }

          const value = data[name];
          if (this.validateRing(name, value)) {
            this.setRingState(name, value);
          }
        });
      }
    );
  }

  getAutoCashOutRing(odd) {
    const autoCashOutMap = {
      [powerOfGodsStore.line2AutoCashOut]: RINGS[1],
      [powerOfGodsStore.line1AutoCashOut]: RINGS[2],
    };
    return autoCashOutMap[odd] ?? null;
  }

  validateRing(name, value) {
    if (!RINGS.includes(name)) {
      // eslint-disable-next-line no-console
      if (isStage()) console.warn(`Invalid ring name: ${name}`);
      return false;
    }
    if (!Number.isInteger(value) || value < 0) {
      // eslint-disable-next-line no-console
      if (isStage()) console.warn(`Invalid ring value for ${name}: ${value}`);
      return false;
    }
    const max = ringMaxStates[name];
    if (value > max) {
      // eslint-disable-next-line no-console
      if (isStage()) console.warn(`Ring value for ${name} exceeds max ${max}: ${value}`);
      return false;
    }
    return true;
  }

  setRingState(name, value) {
    if (!this.validateRing(name, value)) return;
    // console.log('set ring ', name, '  state => ', value);
    this.ringState[name] = value;
  }

  setRingScaleComplete(name, completed = true) {
    if (!RINGS.includes(name)) return;
    // console.log('Set ringLoadingComplete ', name, ' to => ', completed);
    this.ringLoadingComplete[name] = Boolean(completed);
  }

  setResponseData(data, symbol, winInfo, bonusInfo) {
    this.setIsMedusaReversing(symbol === symbolEnum.medusa);
    this.setWinInfo(winInfo);
    this.bonusInfo = bonusInfo
      ? {
          bonusResult: bonusInfo?.bonusResult,
          odd: bonusInfo?.odd,
        }
      : null;
    this.responseData = data;
  }

  setIsMedusaReversing(bool) {
    this.isMedusaReversing = bool;
  }

  setIsZeusDrop(bool) {
    // console.log('SET IS ZEUS DROP TO => ', bool);
    this.isZeusDrop = bool;
  }

  setResponseReady(v) {
    this.responseReady = v;
  }

  setWinInfo(v) {
    this.winInfo = v;
  }

  resetStatesForCashOut(targetStates = {}) {
    RINGS.forEach((name) => {
      const idx = targetStates[name];
      if (this.validateRing(name, idx)) {
        this.setRingState(name, idx);
        this.setRingActionTypeCashOut(name, true);
      }
    });
  }

  setRingActionTypeReverse(name, reverse) {
    this.ringActionTypes[name].reverse = reverse;
  }

  setIsInBonusScene(isInBonusScene) {
    this.isInBonusScene = isInBonusScene;
  }

  setRingActionTypeLineCashOut(name, lineCashOut) {
    if (name !== 'big') this.ringActionTypes[name].lineCashOut = lineCashOut;
  }

  resetAfterCashOut() {
    RINGS.forEach((name) => {
      this.setRingActionTypeCashOut(name, false);
    });
  }

  setRingActionTypeCashOut(name, cashOut) {
    this.ringActionTypes[name].cashOut = cashOut;
  }
}
